import setFaq from './pages/faq';
import setTabs from './pages/abas';
import setMixAndMatch from './pages/mixAndMatch';
import setAbasMenu from './pages/abasMenu';
//addImports

import setTopBar from "../components/topBar";

const Page = {
  init: function () {
    var _this = this;

    setTopBar();

    setFaq()
		setTabs();
		setMixAndMatch();
		setAbasMenu();
		//calls

  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init()
})
